import type { PermissionMode, PermissionName, PermissionStatusMap } from '../types';
import { DesktopPermissionPanel } from './desktop-permission-panel';

interface DesktopPermissionOverlayCardProps {
  mode: PermissionMode;
  missing: readonly PermissionName[];
  statuses: PermissionStatusMap;
  onDismiss: () => void;
  onRequestPermission: (permission: PermissionName) => void;
}

export function DesktopPermissionOverlayCard({
  mode,
  missing,
  statuses,
  onDismiss,
  onRequestPermission,
}: DesktopPermissionOverlayCardProps) {
  return (
    <div
      className="flex size-full min-h-0 items-center justify-center overflow-hidden bg-overlay p-2"
      data-testid="desktop-permission-overlay-card"
    >
      <DesktopPermissionPanel
        mode={mode}
        missing={missing}
        statuses={statuses}
        onDismiss={onDismiss}
        onRequestPermission={onRequestPermission}
      />
    </div>
  );
}
